export class CanvasManager {
  constructor(canvasElement, image) {
    this.canvas = canvasElement
    this.context = this.canvas.getContext('2d')
    this.image = image
    this.aspectRatio = image.width / image.height
    this.initCanvas()
  }

  initCanvas() {
    const container = this.canvas.parentElement
    const displayWidth = Math.min(container.clientWidth, 1200)
    const displayHeight = displayWidth / this.aspectRatio

    this.canvas.style.width = `${displayWidth}px`
    this.canvas.style.height = `${displayHeight}px`

    this.canvas.width = this.image.width
    this.canvas.height = this.image.height

    this.clear()
  }

  clear() {
    this.context.clearRect(0, 0, this.canvas.width, this.canvas.height)
    this.context.drawImage(this.image, 0, 0)
  }

  drawMarkers(points, markerSize) {
    points.forEach(point => {
      this.context.save()
      this.context.beginPath()
      this.context.arc(point.x, point.y, markerSize, 0, Math.PI * 2)
      this.context.fillStyle = 'rgba(0, 255, 0, 0.8)'
      this.context.strokeStyle = 'white'
      this.context.lineWidth = Math.max(1, markerSize * 0.2)
      this.context.fill()
      this.context.stroke()
      this.context.restore()
    })
  }

  drawMidline(points, lineWidth) {
    if (points.length < 2) return

    const [point1, point2] = points
    const distanceX = point2.x - point1.x
    const distanceY = point2.y - point1.y
    const midpoint = {
      x: (point1.x + point2.x) / 2,
      y: (point1.y + point2.y) / 2
    }

    this.context.save()
    this.context.beginPath()
    this.context.moveTo(midpoint.x - distanceY * 50, midpoint.y + distanceX * 50)
    this.context.lineTo(midpoint.x + distanceY * 50, midpoint.y - distanceX * 50)
    this.context.strokeStyle = '#00ff00'
    this.context.lineWidth = lineWidth
    this.context.lineCap = 'round'
    this.context.stroke()
    this.context.restore()
  }

  applyBlurEffect(points, blurWidth, blurHeight, markerSize, midlineWidth) {
    if (points.length < 2) return

    const blurCanvas = this.createBlurCanvas(Math.max(blurWidth, blurHeight) * 0.3)
    const [point1, point2] = points
    const distanceX = point2.x - point1.x
    const distanceY = point2.y - point1.y
    const length = Math.hypot(distanceX, distanceY);
    const angle = Math.atan2(distanceY, distanceX)
    const midpoint = {
      x: (point1.x + point2.x) / 2,
      y: (point1.y + point2.y) / 2
    }

    this.context.save()
    this.context.translate(midpoint.x, midpoint.y)
    this.context.rotate(angle)
    this.context.beginPath()
    this.context.rect(
      -(length + 2 * blurWidth) / 2,
      -blurHeight / 2,
      (length + 2 * blurWidth),
      blurHeight
    )
    this.context.clip()
    this.context.drawImage(blurCanvas, -midpoint.x, -midpoint.y)
    this.context.restore()

    if (midlineWidth) this.drawMidline(points, midlineWidth)
    this.drawMarkers(points, markerSize)
  }

  createBlurCanvas(radius) {
    const blurCanvas = document.createElement('canvas')
    blurCanvas.width = this.image.width
    blurCanvas.height = this.image.height
    const context = blurCanvas.getContext('2d')
    
    context.filter = `blur(${radius}px)`
    context.drawImage(this.image, 0, 0)
    return blurCanvas
  }

  getScaledCoordinates(event) {
    const rect = this.canvas.getBoundingClientRect()
    return {
      x: ((event.clientX - rect.left) / rect.width) * this.canvas.width,
      y: ((event.clientY - rect.top) / rect.height) * this.canvas.height
    }
  }
}
